// Single source of truth for the JustDeliver fee structure (frontend mirror
// of the backend in server.py → calculate_commission). Both fees flow to the
// platform Stripe account.

// Hard platform cap on every bid value — must match MAX_BID_AMOUNT in server.py.
export const MAX_BID_AMOUNT = 1200;
export const MAX_BID_ERROR = `Maximum delivery value on JustDeliver.ie is €${MAX_BID_AMOUNT}.`;

// Fee model (June-2026): flat €10 customer fee, 10% driver fee on bids €100+.
export const CUSTOMER_BOOKING_FEE = 10;
export const DRIVER_ACCESS_FEE_THRESHOLD = 100;
export const DRIVER_ACCESS_FEE_RATE = 0.1;

/**
 * Booking Deposit — flat €10 paid online to JustDeliver on every booking, on
 * top of the driver's bid. Never taken out of the driver's money.
 */
export function bookingFeeFor() {
  return CUSTOMER_BOOKING_FEE;
}

/**
 * JustDeliver Driver Fee — JustDeliver's charge on the bid, paid online by the
 * customer and taken off the amount they pay the driver directly.
 *   €1–€99.99    → €0
 *   €100–€1,200  → 10% of the bid
 */
export function driverAccessFeeFor(amount) {
  const a = Number(amount) || 0;
  if (a < DRIVER_ACCESS_FEE_THRESHOLD) return 0;
  return +(a * DRIVER_ACCESS_FEE_RATE).toFixed(2);
}

export function feeBreakdown(amount) {
  const a = Number(amount) || 0;
  const bookingFee = bookingFeeFor(a);
  const accessFee = driverAccessFeeFor(a);
  return {
    bid: a,
    bookingFee,                         // customer pays JustDeliver online
    accessFee,                          // JustDeliver Driver Fee, paid online by the customer
    customerTotal: +(a + bookingFee).toFixed(2),
    driverPayout: +(a - accessFee).toFixed(2),
  };
}

export const BOOKING_FEE_COPY =
  "The €10 Booking Deposit helps cover secure payments, verified drivers, fraud prevention, customer support and cancellation refund protection. It is never taken out of the driver's amount.";
